import { TLCEventManager } from "../../../../js/lib/events/EventManager";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";


export const StoredImageClientManager = (function () {

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onGetStoredImagesByLogo, function (event) {
		_onGetStoredImagesByLogo("logos");
	});

	var _onGetStoredImagesByLogo = function (category) {
		var url = LS2PAC_CONSTANTS.restUrls.getStoredImagesByCategory + category;
		var success = false,
			response = {images: []};

		TLCRest.jsonCall(url, {
			callback:	  function (data) {
				success = true;
				response = data;
			},
			finallyHandler:function () {
				TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onGetStoredImagesByLogoResponse, {success:success, images:response.images});
			},
			timeout: 20000,
			cancellable: true,
			cache: false
		});
	};

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onUpdateLogo, function (event) {
		_onUpdateLogo(event);
	});

	var _onUpdateLogo = function (event) {
		var success = false,
			response = {};

		var url = LS2PAC_CONSTANTS.restUrls.saveNewLogo + event.imageId + "/logo";

		if(event.imageId === null) {
			url = LS2PAC_CONSTANTS.restUrls.setNoLogo
		}

		TLCRest.jsonCall(url, {
			callback:	  function (data) {
				success = true;
			},
			finallyHandler:function () {
				if(success) {
					ApplicationData.locationConfiguration.setMainLogoUrl(event.imageId);
				}
				TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onUpdateLogoResponse, {success:success, imageId: event.imageId});
			},
			cancellable: true,
			cache: false
		});
	};

	TLCEventManager.addListener(LS2PAC_CONSTANTS.Events.onRemoveStoredImage, function (event) {
		_onRemoveStoredImage(event);
	});

	var _onRemoveStoredImage = function (event) {
		var url = LS2PAC_CONSTANTS.restUrls.removeStoredImage + event.imageId + "/remove",
			success = false,
			response = {};

		TLCRest.jsonCall(url, {
			callback:	  function (data) {
				success = data.success;
			},
			finallyHandler:function () {
				if(success && event.imageId == ApplicationData.locationConfiguration.getMainLogoUrl()) {
					ApplicationData.locationConfiguration.setMainLogoUrl(null);
				}
				TLCEventManager.fireEvent(LS2PAC_CONSTANTS.Events.onRemoveStoredImageResponse, {success:success});
			},
			//timeout: 3000,
			cancellable: true,
			cache: false
		});
	};

	return {};
})();
